import React, { useState, useEffect, useRef } from 'react';
import { Package, Trash2, Plus, Calculator, Box, Weight, Upload, ClipboardPaste, Tag, Moon, Sun, Keyboard, RefreshCw, FileText, FileSpreadsheet } from 'lucide-react';
import * as THREE from 'three';
import * as XLSX from 'xlsx';

// Google AdSense yükleme fonksiyonu
const loadAdSense = () => {
  if (window.adsbygoogle || document.querySelector('script[src*="adsbygoogle"]')) {
    return; // Zaten yüklü
  }
  const script = document.createElement('script');
  script.src = 'https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-2823957520564487';
  script.async = true;
  script.crossOrigin = 'anonymous';
  document.head.appendChild(script);
};

// Çeviriler
const translations = {
  tr: {
    title: 'Konteyner & Truck Yükleme Hesaplayıcı',
    packageInfo: 'Paket Bilgileri',
    excelUpload: 'Excel Yükle',
    paste: 'Yapıştır',
    quantity: 'Adet',
    length: 'Uzunluk (cm)',
    width: 'Genişlik (cm)',
    height: 'Yükseklik (cm)',
    weight: 'Ağırlık (kg)',
    category: 'Kategori',
    selectCategory: 'Seçiniz',
    addPackage: 'Paket Ekle',
    addedPackages: 'Eklenen Paketler:',
    vehicleType: 'Araç Tipi',
    seaContainers: 'Deniz Konteynerleri',
    landTransport: 'Kara Taşıma',
    calculate: 'Hesapla ve Optimizle',
    summary: 'Özet',
    totalVolume: 'Toplam Hacim',
    totalWeight: 'Toplam Ağırlık',
    requiredVehicles: 'Gerekli Araç',
    remainingPackages: 'Kalan Paketler',
    distribution: 'Konteyner/Truck Dağılımı',
    volumeUtilization: 'Hacim Doluluk',
    weightUtilization: 'Ağırlık Doluluk',
    volume: 'Hacim',
    loadedPackages: 'Yüklenen Paketler',
    view3D: '3D Görünüm',
    rotateInfo: 'Fareyi sürükleyerek döndürebilirsiniz',
    blueLines: 'Mavi çizgiler: Konteyner/Truck',
    coloredLines: 'Renkli çizgiler: Paketler (Kategoriye göre)',
    categories: {
      electronic: 'Elektronik',
      textile: 'Tekstil',
      food: 'Gıda',
      furniture: 'Mobilya',
      chemical: 'Kimyasal',
      general: 'Genel'
    },
    shortcuts: 'Klavye Kısayolları',
    shortcutCalc: 'Hesapla',
    shortcutAdd: 'Paket Ekle',
    shortcutClear: 'Temizle',
    newLoad: 'Yeni Yükleme',
    clearPackages: 'Paketleri Sıfırla',
    pdfReport: 'PDF Rapor Oluştur',
    excelExport: 'Excel\'e Aktar'
  },
  en: {
    title: 'Container & Truck Loading Calculator',
    packageInfo: 'Package Information',
    excelUpload: 'Upload Excel',
    paste: 'Paste',
    quantity: 'Quantity',
    length: 'Length (cm)',
    width: 'Width (cm)',
    height: 'Height (cm)',
    weight: 'Weight (kg)',
    category: 'Category',
    selectCategory: 'Select',
    addPackage: 'Add Package',
    addedPackages: 'Added Packages:',
    vehicleType: 'Vehicle Type',
    seaContainers: 'Sea Containers',
    landTransport: 'Land Transport',
    calculate: 'Calculate & Optimize',
    summary: 'Summary',
    totalVolume: 'Total Volume',
    totalWeight: 'Total Weight',
    requiredVehicles: 'Required Vehicles',
    remainingPackages: 'Remaining Packages',
    distribution: 'Container/Truck Distribution',
    volumeUtilization: 'Volume Utilization',
    weightUtilization: 'Weight Utilization',
    volume: 'Volume',
    loadedPackages: 'Loaded Packages',
    view3D: '3D View',
    rotateInfo: 'Drag with mouse to rotate',
    blueLines: 'Blue lines: Container/Truck',
    coloredLines: 'Colored lines: Packages (by category)',
    categories: {
      electronic: 'Electronic',
      textile: 'Textile',
      food: 'Food',
      furniture: 'Furniture',
      chemical: 'Chemical',
      general: 'General'
    },
    shortcuts: 'Keyboard Shortcuts',
    shortcutCalc: 'Calculate',
    shortcutAdd: 'Add Package',
    shortcutClear: 'Clear',
    newLoad: 'New Load',
    clearPackages: 'Clear Packages',
    pdfReport: 'Create PDF Report',
    excelExport: 'Export to Excel'
  },
  ru: {
    title: 'Калькулятор загрузки контейнеров и грузовиков',
    packageInfo: 'Информация о посылке',
    excelUpload: 'Загрузить Excel',
    paste: 'Вставить',
    quantity: 'Количество',
    length: 'Длина (см)',
    width: 'Ширина (см)',
    height: 'Высота (см)',
    weight: 'Вес (кг)',
    category: 'Категория',
    selectCategory: 'Выбрать',
    addPackage: 'Добавить посылку',
    addedPackages: 'Добавленные посылки:',
    vehicleType: 'Тип транспорта',
    seaContainers: 'Морские контейнеры',
    landTransport: 'Наземный транспорт',
    calculate: 'Рассчитать и оптимизировать',
    summary: 'Итого',
    totalVolume: 'Общий объем',
    totalWeight: 'Общий вес',
    requiredVehicles: 'Требуемые транспортные средства',
    remainingPackages: 'Оставшиеся посылки',
    distribution: 'Распределение контейнеров/грузовиков',
    volumeUtilization: 'Использование объема',
    weightUtilization: 'Использование веса',
    volume: 'Объем',
    loadedPackages: 'Загруженные посылки',
    view3D: '3D Вид',
    rotateInfo: 'Перетащите мышью, чтобы повернуть',
    blueLines: 'Синие линии: Контейнер/Грузовик',
    coloredLines: 'Цветные линии: Посылки (по категориям)',
    categories: {
      electronic: 'Электроника',
      textile: 'Текстиль',
      food: 'Еда',
      furniture: 'Мебель',
      chemical: 'Химикаты',
      general: 'Общие'
    },
    shortcuts: 'Горячие клавиши',
    shortcutCalc: 'Рассчитать',
    shortcutAdd: 'Добавить посылку',
    shortcutClear: 'Очистить',
    newLoad: 'Новая загрузка',
    clearPackages: 'Очистить посылки',
    pdfReport: 'Создать PDF отчет',
    excelExport: 'Экспорт в Excel'
  }
};

export default function KonteynerYukleme() {
// Google AdSense'i yükle
  useEffect(() => {
    loadAdSense();
  }, []);

  const [paketler, setPaketler] = useState([]);
  const [adet, setAdet] = useState('');
  const [uzunluk, setUzunluk] = useState('');
  const [genislik, setGenislik] = useState('');
  const [yukseklik, setYukseklik] = useState('');
  const [agirlik, setAgirlik] = useState('');
  const [kategori, setKategori] = useState('');
  const [dondurelebilir, setDondurelebilir] = useState(true);
  const [paletUzerinde, setPaletUzerinde] = useState(false);
  const [maxIstifYuksekligi, setMaxIstifYuksekligi] = useState('');
  const [aracTipi, setAracTipi] = useState('20ft');
  const [ozelAracAcik, setOzelAracAcik] = useState(false);
  const [ozelAracBilgi, setOzelAracBilgi] = useState({
    isim: '',
    uzunluk: '',
    genislik: '',
    yukseklik: '',
    maxAgirlik: ''
  });
  const [sonuc, setSonuc] = useState(null);
  const [seciliKonteyner, setSeciliKonteyner] = useState(0);
  const [topluEklemeAcik, setTopluEklemeAcik] = useState(false);
  const [pasteText, setPasteText] = useState('');
  const [darkMode, setDarkMode] = useState(false);
  const [language, setLanguage] = useState('tr');
  const [shortcutsVisible, setShortcutsVisible] = useState(false);
  const canvasRef = useRef(null);
  const sceneRef = useRef(null);
  const fileInputRef = useRef(null);

  const t = translations[language];

  const aracOlculeri = {
    '20ft': { 
      isim: '20ft Container',
      uzunluk: 589, 
      genislik: 235, 
      yukseklik: 239, 
      hacim: 33.2,
      maxAgirlik: 28000
    },
    '40ft': { 
      isim: '40ft Container',
      uzunluk: 1203, 
      genislik: 235, 
      yukseklik: 239, 
      hacim: 67.7,
      maxAgirlik: 26500
    },
    '20ft-hc': { 
      isim: '20ft High Cube',
      uzunluk: 589, 
      genislik: 235, 
      yukseklik: 269,
      hacim: 37.4,
      maxAgirlik: 28000
    },
    '40ft-hc': { 
      isim: '40ft High Cube',
      uzunluk: 1203, 
      genislik: 235, 
      yukseklik: 269, 
      hacim: 76.0,
      maxAgirlik: 26500
    },
    '20ft-reefer': { 
      isim: '20ft Reefer',
      uzunluk: 538, 
      genislik: 228, 
      yukseklik: 217,
      hacim: 26.6,
      maxAgirlik: 27400
    },
    '40ft-reefer': { 
      isim: '40ft Reefer',
      uzunluk: 1150, 
      genislik: 226, 
      yukseklik: 217, 
      hacim: 56.4,
      maxAgirlik: 27700
    },
    '20ft-opentop': { 
      isim: '20ft Open Top',
      uzunluk: 589, 
      genislik: 235, 
      yukseklik: 239,
      hacim: 33.2,
      maxAgirlik: 28000
    },
    '40ft-opentop': { 
      isim: '40ft Open Top',
      uzunluk: 1203, 
      genislik: 235, 
      yukseklik: 239, 
      hacim: 67.7,
      maxAgirlik: 26500
    },
    'standart-truck': {
      isim: 'Standard Truck',
      uzunluk: 600,
      genislik: 240,
      yukseklik: 240,
      hacim: 34.6,
      maxAgirlik: 12000
    },
    'mega-trailer': {
      isim: 'Mega Trailer',
      uzunluk: 1360,
      genislik: 245,
      yukseklik: 270,
      hacim: 90.0,
      maxAgirlik: 24000
    },
    'jumbo-trailer': {
      isim: 'Jumbo Trailer',
      uzunluk: 1360,
      genislik: 248,
      yukseklik: 300,
      hacim: 101.6,
      maxAgirlik: 24000
    },
    'custom': ozelAracBilgi.isim ? {
      isim: ozelAracBilgi.isim,
      uzunluk: parseFloat(ozelAracBilgi.uzunluk) || 0,
      genislik: parseFloat(ozelAracBilgi.genislik) || 0,
      yukseklik: parseFloat(ozelAracBilgi.yukseklik) || 0,
      hacim: ((parseFloat(ozelAracBilgi.uzunluk) || 0) * (parseFloat(ozelAracBilgi.genislik) || 0) * (parseFloat(ozelAracBilgi.yukseklik) || 0)) / 1000000,
      maxAgirlik: parseFloat(ozelAracBilgi.maxAgirlik) || 0
    } : {
      isim: 'Custom Vehicle',
      uzunluk: 1000,
      genislik: 240,
      yukseklik: 240,
      hacim: 57.6,
      maxAgirlik: 20000
    }
  };

  const kategoriRenkleri = {
    // Türkçe
    'Elektronik': '#3b82f6',
    'Tekstil': '#8b5cf6',
    'Gıda': '#10b981',
    'Mobilya': '#f59e0b',
    'Kimyasal': '#ef4444',
    'Genel': '#6b7280',
    // English
    'Electronic': '#3b82f6',
    'Textile': '#8b5cf6',
    'Food': '#10b981',
    'Furniture': '#f59e0b',
    'Chemical': '#ef4444',
    'General': '#6b7280',
    // Русский
    'Электроника': '#3b82f6',
    'Текстиль': '#8b5cf6',
    'Еда': '#10b981',
    'Мебель': '#f59e0b',
    'Химикаты': '#ef4444',
    'Общие': '#6b7280'
  };

  const yeniYukleme = () => {
    setPaketler([]);
    setSonuc(null);
    setSeciliKonteyner(0);
    setAdet('');
    setUzunluk('');
    setGenislik('');
    setYukseklik('');
    setAgirlik('');
    setKategori('');
    setDondurelebilir(true);
    setPaletUzerinde(false);
    setMaxIstifYuksekligi('');
  };

  useEffect(() => {
    const handleKeyPress = (e) => {
      if ((e.ctrlKey || e.metaKey) && e.key === 'Enter') {
        e.preventDefault();
        hesapla();
      }
      if ((e.ctrlKey || e.metaKey) && e.key === 'n') {
        e.preventDefault();
        document.getElementById('adet-input')?.focus();
      }
      if ((e.ctrlKey || e.metaKey) && e.key === 'k') {
        e.preventDefault();
        setShortcutsVisible(!shortcutsVisible);
      }
      if (e.key === 'Escape') {
        setShortcutsVisible(false);
        setTopluEklemeAcik(false);
      }
    };

    window.addEventListener('keydown', handleKeyPress);
    return () => window.removeEventListener('keydown', handleKeyPress);
  }, [shortcutsVisible]);

  const paketEkle = () => {
    if (adet && uzunluk && genislik && yukseklik && agirlik) {
      const temizAdet = parseInt(adet.toString().replace(',', '.'));
      const temizUzunluk = parseFloat(uzunluk.toString().replace(',', '.'));
      const temizGenislik = parseFloat(genislik.toString().replace(',', '.'));
      const temizYukseklik = parseFloat(yukseklik.toString().replace(',', '.'));
      const temizAgirlik = parseFloat(agirlik.toString().replace(',', '.'));
      
      if (isNaN(temizAdet) || isNaN(temizUzunluk) || isNaN(temizGenislik) || 
          isNaN(temizYukseklik) || isNaN(temizAgirlik)) {
        alert('Lütfen geçerli sayılar girin!');
        return;
      }
      
      if (temizAdet <= 0 || temizUzunluk <= 0 || temizGenislik <= 0 || 
          temizYukseklik <= 0 || temizAgirlik <= 0) {
        alert('Tüm değerler pozitif olmalı!');
        return;
      }
      
      const yeniPaket = {
        id: Date.now(),
        adet: temizAdet,
        uzunluk: temizUzunluk,
        genislik: temizGenislik,
        yukseklik: temizYukseklik,
        agirlik: temizAgirlik,
        kategori: kategori || t.categories.general,
        dondurelebilir: dondurelebilir,
        paletUzerinde: paletUzerinde,
        maxIstifYuksekligi: maxIstifYuksekligi ? parseFloat(maxIstifYuksekligi) : null
      };
      setPaketler([...paketler, yeniPaket]);
      setAdet('');
      setUzunluk('');
      setGenislik('');
      setYukseklik('');
      setAgirlik('');
      setKategori('');
      setDondurelebilir(true);
      setPaletUzerinde(false);
      setMaxIstifYuksekligi('');
    } else {
      alert('Lütfen tüm alanları doldurun!');
    }
  };

  const paketSil = (id) => {
    setPaketler(paketler.filter(p => p.id !== id));
  };

  const excelYukle = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = (evt) => {
      try {
        const data = evt.target.result;
        const workbook = XLSX.read(data, { type: 'binary' });
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];
        const jsonData = XLSX.utils.sheet_to_json(worksheet);

        const yeniPaketler = [];
        jsonData.forEach((row, index) => {
          const adet = row.Adet || row.adet || row.ADET || row.Quantity || 0;
          const uzunluk = row.Uzunluk || row.uzunluk || row.Length || 0;
          const genislik = row.Genişlik || row.Genislik || row.Width || 0;
          const yukseklik = row.Yükseklik || row.Yukseklik || row.Height || 0;
          const agirlik = row.Ağırlık || row.Agirlik || row.Weight || 0;
          const kategori = row.Kategori || row.kategori || row.Category || t.categories.general;

          if (adet > 0 && uzunluk > 0 && genislik > 0 && yukseklik > 0 && agirlik > 0) {
            yeniPaketler.push({
              id: Date.now() + index,
              adet: parseInt(adet),
              uzunluk: parseFloat(uzunluk),
              genislik: parseFloat(genislik),
              yukseklik: parseFloat(yukseklik),
              agirlik: parseFloat(agirlik),
              kategori: kategori,
              dondurelebilir: true,
              paletUzerinde: false,
              maxIstifYuksekligi: null
            });
          }
        });

        if (yeniPaketler.length > 0) {
          setPaketler([...paketler, ...yeniPaketler]);
          alert(`${yeniPaketler.length} paket başarıyla yüklendi!`);
        } else {
          alert('Excel dosyasında geçerli paket bulunamadı.');
        }
      } catch (error) {
        alert('Excel dosyası okuma hatası!');
        console.error(error);
      }
    };
    reader.readAsBinaryString(file);
    e.target.value = '';
  };

  const pastedenEkle = () => {
    if (!pasteText.trim()) {
      alert('Lütfen veri yapıştırın!');
      return;
    }

    try {
      const satirlar = pasteText.trim().split('\n');
      const yeniPaketler = [];

      satirlar.forEach((satir, index) => {
        const degerler = satir.split(/[\t,]/);
        
        if (degerler.length >= 5) {
          const adet = parseInt(degerler[0]);
          const uzunluk = parseFloat(degerler[1]);
          const genislik = parseFloat(degerler[2]);
          const yukseklik = parseFloat(degerler[3]);
          const agirlik = parseFloat(degerler[4]);
          const kategori = degerler[5] || t.categories.general;

          if (!isNaN(adet) && !isNaN(uzunluk) && !isNaN(genislik) && 
              !isNaN(yukseklik) && !isNaN(agirlik) &&
              adet > 0 && uzunluk > 0 && genislik > 0 && yukseklik > 0 && agirlik > 0) {
            yeniPaketler.push({
              id: Date.now() + index,
              adet,
              uzunluk,
              genislik,
              yukseklik,
              agirlik,
              kategori,
              dondurelebilir: true,
              paletUzerinde: false,
              maxIstifYuksekligi: null
            });
          }
        }
      });

      if (yeniPaketler.length > 0) {
        setPaketler([...paketler, ...yeniPaketler]);
        setPasteText('');
        setTopluEklemeAcik(false);
        alert(`${yeniPaketler.length} paket eklendi!`);
      } else {
        alert('Geçerli paket bulunamadı!');
      }
    } catch (error) {
      alert('Veri işleme hatası!');
      console.error(error);
    }
  };

  const benzersizKategoriler = [...new Set(paketler.map(p => p.kategori))];

  const excelAktar = () => {
    if (!sonuc || sonuc.hata) {
      alert('Önce hesaplama yapın!');
      return;
    }

    try {
      const workbook = XLSX.utils.book_new();

      // Sayfa 1: Özet
      const ozetData = [
        ['YÜKLEME PLANI ÖZETİ'],
        [''],
        ['Rapor Tarihi:', new Date().toLocaleString('tr-TR')],
        ['Araç Tipi:', sonuc.aracIsim],
        ['Araç Boyutları:', `${aracOlculeri[aracTipi].uzunluk}×${aracOlculeri[aracTipi].genislik}×${aracOlculeri[aracTipi].yukseklik} cm`],
        ['Araç Hacmi:', `${aracOlculeri[aracTipi].hacim} m³`],
        ['Max Ağırlık:', `${aracOlculeri[aracTipi].maxAgirlik.toLocaleString()} kg`],
        [''],
        ['Toplam Hacim:', `${sonuc.toplamHacim} m³`],
        ['Toplam Ağırlık:', `${sonuc.toplamAgirlik} kg`],
        ['Gerekli Araç Sayısı:', sonuc.gerekenArac],
      ];
      const ozetSheet = XLSX.utils.aoa_to_sheet(ozetData);
      XLSX.utils.book_append_sheet(workbook, ozetSheet, 'Özet');

      // Sayfa 2: Paket Listesi
      const paketData = [
        ['PAKET LİSTESİ'],
        [''],
        ['Adet', 'Uzunluk (cm)', 'Genişlik (cm)', 'Yükseklik (cm)', 'Ağırlık (kg)', 'Kategori', 'Döndürülebilir', 'Palet', 'Max İstif (cm)']
      ];
      
      paketler.forEach(paket => {
        paketData.push([
          paket.adet,
          paket.uzunluk,
          paket.genislik,
          paket.yukseklik,
          paket.agirlik,
          paket.kategori,
          paket.dondurelebilir ? 'Evet' : 'Hayır',
          paket.paletUzerinde ? 'Evet' : 'Hayır',
          paket.maxIstifYuksekligi || '-'
        ]);
      });
      
      const paketSheet = XLSX.utils.aoa_to_sheet(paketData);
      XLSX.utils.book_append_sheet(workbook, paketSheet, 'Paket Listesi');

      // Sayfa 3+: Her konteyner için ayrı sayfa
      sonuc.konteynerler.forEach((konteyner, index) => {
        const konteynerData = [
          [`${index + 1}. ${sonuc.aracIsim}`],
          [''],
          ['Hacim Kullanımı:', `${konteyner.dolulukOrani}%`, `(${konteyner.kullanilanHacim} / ${aracOlculeri[aracTipi].hacim} m³)`],
          ['Ağırlık Kullanımı:', `${konteyner.agirlikOrani}%`, `(${konteyner.kullanilanAgirlik} / ${aracOlculeri[aracTipi].maxAgirlik} kg)`],
          [''],
          ['YÜKLENEN PAKETLER'],
          [''],
          ['Adet', 'Uzunluk (cm)', 'Genişlik (cm)', 'Yükseklik (cm)', 'Ağırlık (kg)', 'Kategori']
        ];

        konteyner.paketler.forEach(paket => {
          konteynerData.push([
            paket.yuklenecekAdet,
            paket.uzunluk,
            paket.genislik,
            paket.yukseklik,
            paket.agirlik,
            paket.kategori
          ]);
        });

        const konteynerSheet = XLSX.utils.aoa_to_sheet(konteynerData);
        XLSX.utils.book_append_sheet(workbook, konteynerSheet, `Araç ${index + 1}`);
      });

      // Kalan paketler varsa
      if (sonuc.kalanPaketler.length > 0) {
        const kalanData = [
          ['YÜKLENEMEYEN PAKETLER'],
          [''],
          ['Kalan Adet', 'Uzunluk (cm)', 'Genişlik (cm)', 'Yükseklik (cm)', 'Ağırlık (kg)', 'Kategori']
        ];

        sonuc.kalanPaketler.forEach(paket => {
          kalanData.push([
            paket.kalanAdet,
            paket.uzunluk,
            paket.genislik,
            paket.yukseklik,
            paket.agirlik,
            paket.kategori
          ]);
        });

        const kalanSheet = XLSX.utils.aoa_to_sheet(kalanData);
        XLSX.utils.book_append_sheet(workbook, kalanSheet, 'Kalan Paketler');
      }

      // Excel dosyasını indir
      const tarih = new Date().toISOString().split('T')[0];
      XLSX.writeFile(workbook, `Yukleme-Plani-${tarih}.xlsx`);
      
    } catch (error) {
      console.error('Excel oluşturma hatası:', error);
      alert('❌ Excel oluşturulurken bir hata oluştu!');
    }
  };

  const pdfRaporOlustur = () => {
    if (!sonuc || sonuc.hata) {
      alert('Önce hesaplama yapın!');
      return;
    }

    try {
      const tarih = new Date().toLocaleDateString('tr-TR', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      });

      let htmlContent = `<!DOCTYPE html>
<html>
<head>
  <meta charset="UTF-8">
  <title>Yükleme Planı Raporu</title>
  <style>
    @media print {
      body { margin: 0; }
      .page-break { page-break-after: always; }
      @page { margin: 2cm; }
    }
    body {
      font-family: Arial, sans-serif;
      margin: 20px;
      color: #000;
      background: white;
    }
    .header {
      background: #2563eb;
      color: white;
      padding: 20px;
      text-align: center;
      margin-bottom: 20px;
    }
    .header h1 {
      margin: 0;
      font-size: 28px;
    }
    .info-box {
      background: #f0f9ff;
      border: 2px solid #2563eb;
      padding: 15px;
      margin: 20px 0;
      border-radius: 8px;
    }
    .summary-box {
      display: inline-block;
      background: #f0f9ff;
      border: 2px solid #2563eb;
      border-radius: 8px;
      padding: 15px;
      margin: 10px 10px 10px 0;
      min-width: 200px;
      vertical-align: top;
    }
    .summary-label {
      font-size: 12px;
      color: #64748b;
      text-transform: uppercase;
    }
    .summary-value {
      font-size: 24px;
      font-weight: bold;
      color: #2563eb;
      margin-top: 5px;
    }
    table {
      width: 100%;
      border-collapse: collapse;
      margin: 15px 0;
      background: white;
    }
    th {
      background: #2563eb;
      color: white;
      padding: 12px;
      text-align: left;
      font-weight: bold;
    }
    td {
      padding: 10px 12px;
      border-bottom: 1px solid #e2e8f0;
    }
    tr:nth-child(even) {
      background: #f8fafc;
    }
    .container-section {
      background: #f9fafb;
      border: 2px solid #e5e7eb;
      border-radius: 8px;
      padding: 20px;
      margin: 20px 0;
      page-break-inside: avoid;
    }
    .warning {
      background: #fef3c7;
      border-left: 4px solid #f59e0b;
      padding: 12px;
      margin: 15px 0;
    }
    .progress-bar {
      background: #e5e7eb;
      height: 25px;
      border-radius: 12px;
      overflow: hidden;
      margin: 8px 0;
      position: relative;
    }
    .progress-fill {
      height: 100%;
      background: #10b981;
      position: absolute;
      left: 0;
      top: 0;
    }
    .progress-text {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      color: white;
      font-weight: bold;
      font-size: 12px;
      z-index: 1;
      text-shadow: 1px 1px 2px rgba(0,0,0,0.5);
    }
    .footer {
      margin-top: 50px;
      text-align: center;
      color: #64748b;
      font-size: 12px;
      border-top: 1px solid #e2e8f0;
      padding-top: 20px;
    }
    .print-button {
      position: fixed;
      top: 20px;
      right: 20px;
      background: #2563eb;
      color: white;
      padding: 15px 30px;
      border: none;
      border-radius: 8px;
      cursor: pointer;
      font-size: 16px;
      font-weight: bold;
      box-shadow: 0 4px 6px rgba(0,0,0,0.1);
    }
    .print-button:hover {
      background: #1d4ed8;
    }
    @media print {
      .print-button { display: none; }
    }
  </style>
</head>
<body>
  <button class="print-button" onclick="window.print()">🖨️ PDF Olarak Kaydet</button>

  <div class="header">
    <h1>📦 YÜKLEME PLANI RAPORU</h1>
    <p style="margin: 10px 0 0 0; font-size: 14px;">Tarih: ${tarih}</p>
  </div>

  <div class="info-box">
    <h2 style="margin-top: 0;">📊 Genel Bilgiler</h2>
    <p><strong>Araç Tipi:</strong> ${sonuc.aracIsim}</p>
    <p><strong>Toplam Araç Sayısı:</strong> ${sonuc.gerekenArac}</p>
    <p><strong>Toplam Yük:</strong> ${sonuc.toplamAgirlik} kg / ${sonuc.toplamHacim} m³</p>
  </div>

  <h2>📊 GENEL ÖZET</h2>
  
  <div class="summary-box">
    <div class="summary-label">Toplam Hacim</div>
    <div class="summary-value">${sonuc.toplamHacim} m³</div>
  </div>
  
  <div class="summary-box">
    <div class="summary-label">Toplam Ağırlık</div>
    <div class="summary-value">${sonuc.toplamAgirlik} kg</div>
  </div>
  
  <div class="summary-box">
    <div class="summary-label">Gerekli Araç</div>
    <div class="summary-value">${sonuc.gerekenArac}</div>
  </div>

  <div class="page-break"></div>

  <h2>📋 PAKET LİSTESİ</h2>
  <table>
    <thead>
      <tr>
        <th>Adet</th>
        <th>Boyutlar (cm)</th>
        <th>Ağırlık (kg)</th>
        <th>Kategori</th>
      </tr>
    </thead>
    <tbody>`;

      paketler.forEach(paket => {
        htmlContent += `
      <tr>
        <td><strong>${paket.adet}×</strong></td>
        <td>${paket.uzunluk} × ${paket.genislik} × ${paket.yukseklik}</td>
        <td>${paket.agirlik} kg</td>
        <td>${paket.kategori}</td>
      </tr>`;
      });

      htmlContent += `
    </tbody>
  </table>

  <div class="page-break"></div>`;

      sonuc.konteynerler.forEach((konteyner, index) => {
        htmlContent += `
  <div class="container-section">
    <h2>🚛 ${index + 1}. ${sonuc.aracIsim}</h2>
    
    <p><strong>Hacim Kullanımı:</strong></p>
    <div class="progress-bar">
      <div class="progress-fill" style="width: ${konteyner.dolulukOrani}%; background: #10b981;"></div>
      <div class="progress-text">${konteyner.dolulukOrani}% (${konteyner.kullanilanHacim} m³)</div>
    </div>
    
    <p><strong>Ağırlık Kullanımı:</strong></p>
    <div class="progress-bar">
      <div class="progress-fill" style="width: ${konteyner.agirlikOrani}%; background: #f59e0b;"></div>
      <div class="progress-text">${konteyner.agirlikOrani}% (${konteyner.kullanilanAgirlik} kg)</div>
    </div>
    
    <h3>📦 Yüklenen Paketler</h3>
    <table>
      <thead>
        <tr>
          <th>Adet</th>
          <th>Boyutlar (cm)</th>
          <th>Ağırlık (kg)</th>
          <th>Kategori</th>
        </tr>
      </thead>
      <tbody>`;

        konteyner.paketler.forEach(paket => {
          htmlContent += `
        <tr>
          <td><strong>${paket.yuklenecekAdet}×</strong></td>
          <td>${paket.uzunluk} × ${paket.genislik} × ${paket.yukseklik}</td>
          <td>${paket.agirlik} kg</td>
          <td>${paket.kategori}</td>
        </tr>`;
        });

        htmlContent += `
      </tbody>
    </table>
  </div>

  ${index < sonuc.konteynerler.length - 1 ? '<div class="page-break"></div>' : ''}
`;
      });

      if (sonuc.kalanPaketler && sonuc.kalanPaketler.length > 0) {
        htmlContent += `
  <div class="page-break"></div>
  <div class="warning">
    <h2 style="margin-top: 0;">⚠️ UYARI: YÜKLENEMEYEN PAKETLER</h2>
    <p>Aşağıdaki paketler mevcut araçlara sığmadı. Ek araç gerekli!</p>
  </div>
  
  <table>
    <thead>
      <tr>
        <th>Kalan Adet</th>
        <th>Boyutlar (cm)</th>
        <th>Ağırlık (kg)</th>
        <th>Kategori</th>
      </tr>
    </thead>
    <tbody>`;

        sonuc.kalanPaketler.forEach(paket => {
          htmlContent += `
      <tr>
        <td><strong>${paket.kalanAdet}×</strong></td>
        <td>${paket.uzunluk} × ${paket.genislik} × ${paket.yukseklik}</td>
        <td>${paket.agirlik} kg</td>
        <td>${paket.kategori}</td>
      </tr>`;
        });

        htmlContent += `
    </tbody>
  </table>`;
      }

      htmlContent += `
  <div class="footer">
    <p>Bu rapor Konteyner & Truck Yükleme Hesaplayıcı tarafından otomatik oluşturulmuştur.</p>
    <p>Rapor Tarihi: ${tarih}</p>
  </div>
</body>
</html>`;

      // HTML dosyasını blob olarak oluştur ve indir
      const blob = new Blob([htmlContent], { type: 'text/html' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      const dosyaTarihi = new Date().toISOString().split('T')[0];
      a.download = `Yukleme-Plani-${dosyaTarihi}.html`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
      
      alert('✅ Rapor indirildi! HTML dosyasını açıp "PDF olarak kaydet" butonuna tıklayın.');
      
    } catch (error) {
      console.error('PDF oluşturma hatası:', error);
      alert('❌ PDF oluşturulurken bir hata oluştu!');
    }
  };

  const optimizeEt = (mevcutPaketler, konteynerOlcu) => {
    try {
      const sonuclar = [];
      const havuz = {};
      mevcutPaketler.forEach(p => {
        havuz[p.id] = p.adet;
      });
      
      let konteynerSayaci = 0;
      const maxKonteyner = 100;
      
      while (Object.values(havuz).some(adet => adet > 0) && konteynerSayaci < maxKonteyner) {
        konteynerSayaci++;
        
        const konteynerHacim = konteynerOlcu.hacim * 1000000;
        const maxAgirlik = konteynerOlcu.maxAgirlik;
        
        const yerlestirilen = {};
        let kullanilanHacim = 0;
        
        const paketListesi = mevcutPaketler
          .filter(p => havuz[p.id] > 0)
          .map(p => ({
            ...p,
            paketHacim: p.paletUzerinde ? 
              (120 * 80 * (p.yukseklik + 15)) : 
              (p.uzunluk * p.genislik * p.yukseklik)
          }))
          .sort((a, b) => b.paketHacim - a.paketHacim);
        
        let eklemeDevam = true;
        while (eklemeDevam) {
          eklemeDevam = false;
          
          for (const paket of paketListesi) {
            if (havuz[paket.id] <= 0) continue;
            
            if (paket.uzunluk > konteynerOlcu.uzunluk || 
                paket.genislik > konteynerOlcu.genislik || 
                paket.yukseklik > konteynerOlcu.yukseklik) {
              continue;
            }
            
            if (kullanilanHacim + paket.paketHacim <= konteynerHacim * 0.85) {
              yerlestirilen[paket.id] = (yerlestirilen[paket.id] || 0) + 1;
              havuz[paket.id] -= 1;
              kullanilanHacim += paket.paketHacim;
              eklemeDevam = true;
            }
          }
        }
        
        if (Object.keys(yerlestirilen).length === 0) {
          break;
        }
        
        let toplamAgirlik = 0;
        for (const paketId in yerlestirilen) {
          const paket = mevcutPaketler.find(p => p.id == paketId);
          toplamAgirlik += paket.agirlik * yerlestirilen[paketId];
        }
        
        if (toplamAgirlik > maxAgirlik) {
          const paketBilgileri = Object.keys(yerlestirilen).map(paketId => {
            const paket = mevcutPaketler.find(p => p.id == paketId);
            const paketHacim = paket.uzunluk * paket.genislik * paket.yukseklik;
            return {
              id: paket.id,
              agirlik: paket.agirlik,
              hacim: paketHacim,
              oran: paket.agirlik / paketHacim,
              yukluAdet: yerlestirilen[paketId]
            };
          }).sort((a, b) => b.oran - a.oran);
          
          while (toplamAgirlik > maxAgirlik) {
            let cikarildi = false;
            
            for (const bilgi of paketBilgileri) {
              if (yerlestirilen[bilgi.id] > 0) {
                yerlestirilen[bilgi.id] -= 1;
                havuz[bilgi.id] += 1;
                kullanilanHacim -= bilgi.hacim;
                toplamAgirlik -= bilgi.agirlik;
                cikarildi = true;
                
                if (yerlestirilen[bilgi.id] === 0) {
                  delete yerlestirilen[bilgi.id];
                }
                
                break;
              }
            }
            
            if (!cikarildi) break;
          }
        }
        
        if (Object.keys(yerlestirilen).length === 0) {
          break;
        }
        
        const konteynerPaketleri = [];
        for (const paketId in yerlestirilen) {
          const paket = mevcutPaketler.find(p => p.id == paketId);
          konteynerPaketleri.push({
            id: paket.id,
            uzunluk: paket.uzunluk,
            genislik: paket.genislik,
            yukseklik: paket.yukseklik,
            agirlik: paket.agirlik,
            kategori: paket.kategori,
            dondurelebilir: paket.dondurelebilir,
            paletUzerinde: paket.paletUzerinde,
            maxIstifYuksekligi: paket.maxIstifYuksekligi,
            yuklenecekAdet: yerlestirilen[paketId]
          });
        }
        
        const dolulukOrani = (kullanilanHacim / konteynerHacim) * 100;
        const agirlikOrani = (toplamAgirlik / maxAgirlik) * 100;
        
        sonuclar.push({
          paketler: konteynerPaketleri,
          kullanilanHacim: (kullanilanHacim / 1000000).toFixed(2),
          kullanilanAgirlik: toplamAgirlik.toFixed(0),
          dolulukOrani: Math.min(dolulukOrani, 100).toFixed(1),
          agirlikOrani: Math.min(agirlikOrani, 100).toFixed(1)
        });
      }
      
      return sonuclar;
    } catch (error) {
      console.error('Optimization error:', error);
      return [];
    }
  };

  const paketleriYerlestir = (paketListesi, konteynerOlcu) => {
    const yerlestirilenler = [];
    const tumPaketler = [];
    
    const PALET_UZUNLUK = 120;
    const PALET_GENISLIK = 80;
    const PALET_YUKSEKLIK = 15;
    
    paketListesi.forEach(paket => {
      for (let i = 0; i < paket.yuklenecekAdet; i++) {
        let paketBoyutlar = {
          uzunluk: paket.uzunluk,
          genislik: paket.genislik,
          yukseklik: paket.yukseklik
        };
        
        if (paket.paletUzerinde) {
          paketBoyutlar = {
            uzunluk: PALET_UZUNLUK,
            genislik: PALET_GENISLIK,
            yukseklik: paket.yukseklik + PALET_YUKSEKLIK
          };
        }
        
        tumPaketler.push({
          ...paketBoyutlar,
          originalUzunluk: paket.uzunluk,
          originalGenislik: paket.genislik,
          originalYukseklik: paket.yukseklik,
          hacim: (paketBoyutlar.uzunluk * paketBoyutlar.genislik * paketBoyutlar.yukseklik) / 1000000,
          renkId: paket.id,
          kategori: paket.kategori,
          dondurelebilir: paket.dondurelebilir,
          paletUzerinde: paket.paletUzerinde,
          maxIstifYuksekligi: paket.maxIstifYuksekligi,
          agirlik: paket.agirlik
        });
      }
    });

    tumPaketler.sort((a, b) => b.hacim - a.hacim);

    let x = 0, y = 0, z = 0;
    let katYukseklik = 0;
    let satirGenislik = 0;
    const istifMap = new Map();

    tumPaketler.forEach(paket => {
      let yerlestirildi = false;
      
      const oryantasyonlar = [];
      if (paket.dondurelebilir && !paket.paletUzerinde) {
        oryantasyonlar.push({ u: paket.uzunluk, g: paket.genislik, y: paket.yukseklik });
        oryantasyonlar.push({ u: paket.genislik, g: paket.uzunluk, y: paket.yukseklik });
        if (!paket.maxIstifYuksekligi || paket.uzunluk <= paket.maxIstifYuksekligi) {
          oryantasyonlar.push({ u: paket.yukseklik, g: paket.genislik, y: paket.uzunluk });
        }
      } else {
        oryantasyonlar.push({ u: paket.uzunluk, g: paket.genislik, y: paket.yukseklik });
      }
      
      for (const ory of oryantasyonlar) {
        if (yerlestirildi) break;
        
        if (x + ory.u > konteynerOlcu.uzunluk) {
          x = 0;
          z += satirGenislik;
          satirGenislik = 0;
        }

        if (z + ory.g > konteynerOlcu.genislik) {
          x = 0;
          z = 0;
          y += katYukseklik;
          katYukseklik = 0;
        }

        const pozisyonKey = `${Math.floor(x/10)}-${Math.floor(z/10)}`;
        const mevcutIstifYuksekligi = istifMap.get(pozisyonKey) || 0;
        
        let istifEdilmis = false;
        if (paket.maxIstifYuksekligi && mevcutIstifYuksekligi > 0) {
          if (mevcutIstifYuksekligi + ory.y <= paket.maxIstifYuksekligi) {
            istifEdilmis = true;
          } else {
            continue;
          }
        }

        if (x + ory.u <= konteynerOlcu.uzunluk &&
            y + ory.y <= konteynerOlcu.yukseklik &&
            z + ory.g <= konteynerOlcu.genislik) {
          
          yerlestirilenler.push({
            x: x + ory.u / 2,
            y: y + ory.y / 2,
            z: z + ory.g / 2,
            uzunluk: ory.u,
            genislik: ory.g,
            yukseklik: ory.y,
            renkId: paket.renkId,
            kategori: paket.kategori,
            paletUzerinde: paket.paletUzerinde,
            agirlik: paket.agirlik
          });

          if (istifEdilmis) {
            istifMap.set(pozisyonKey, mevcutIstifYuksekligi + ory.y);
          } else {
            istifMap.set(pozisyonKey, ory.y);
          }

          x += ory.u;
          satirGenislik = Math.max(satirGenislik, ory.g);
          katYukseklik = Math.max(katYukseklik, ory.y);
          yerlestirildi = true;
        }
      }
    });

    return yerlestirilenler;
  };

  useEffect(() => {
    if (!sonuc || sonuc.hata || !canvasRef.current || !sonuc.konteynerler) return;

    if (sceneRef.current) {
      sceneRef.current.children.forEach(child => {
        if (child.geometry) child.geometry.dispose();
        if (child.material) child.material.dispose();
      });
    }

    const canvas = canvasRef.current;
    const scene = new THREE.Scene();
    sceneRef.current = scene;
    scene.background = new THREE.Color(darkMode ? 0x1a1a1a : 0xf0f4f8);

    const camera = new THREE.PerspectiveCamera(
      50,
      canvas.clientWidth / canvas.clientHeight,
      1,
      10000
    );

    const renderer = new THREE.WebGLRenderer({ canvas, antialias: true });
    renderer.setSize(canvas.clientWidth, canvas.clientHeight);

    const arac = aracOlculeri[aracTipi];
    const seciliKonteynerData = sonuc.konteynerler[seciliKonteyner];

    const konteynerGeometry = new THREE.BoxGeometry(
      arac.uzunluk,
      arac.yukseklik,
      arac.genislik
    );
    const konteynerEdges = new THREE.EdgesGeometry(konteynerGeometry);
    const konteynerLine = new THREE.LineSegments(
      konteynerEdges,
      new THREE.LineBasicMaterial({ color: darkMode ? 0x60a5fa : 0x2563eb, linewidth: 2 })
    );
    konteynerLine.position.set(arac.uzunluk / 2, arac.yukseklik / 2, arac.genislik / 2);
    scene.add(konteynerLine);

    const yerlestirilenPaketler = paketleriYerlestir(seciliKonteynerData.paketler, arac);
    
    const renkMap = new Map();
    seciliKonteynerData.paketler.forEach((paket) => {
      const kategoriRenk = kategoriRenkleri[paket.kategori] || kategoriRenkleri['Genel'];
      renkMap.set(paket.id, new THREE.Color(kategoriRenk));
    });
    
    yerlestirilenPaketler.forEach((paket) => {
      const paketGeometry = new THREE.BoxGeometry(
        paket.uzunluk,
        paket.yukseklik,
        paket.genislik
      );
      const paketEdges = new THREE.EdgesGeometry(paketGeometry);
      const color = renkMap.get(paket.renkId);
      
      const lineWidth = paket.paletUzerinde ? 2.5 : 1.5;
      
      const paketLine = new THREE.LineSegments(
        paketEdges,
        new THREE.LineBasicMaterial({ color: color, linewidth: lineWidth })
      );
      paketLine.position.set(paket.x, paket.y, paket.z);
      scene.add(paketLine);
      
      if (paket.paletUzerinde) {
        const paletGeometry = new THREE.BoxGeometry(120, 15, 80);
        const paletEdges = new THREE.EdgesGeometry(paletGeometry);
        const paletLine = new THREE.LineSegments(
          paletEdges,
          new THREE.LineBasicMaterial({ color: 0x8b4513, linewidth: 2 })
        );
        paletLine.position.set(paket.x, paket.y - paket.yukseklik/2 - 7.5, paket.z);
        scene.add(paletLine);
      }
    });

    const maxDim = Math.max(arac.uzunluk, arac.genislik, arac.yukseklik);
    camera.position.set(maxDim * 1.5, maxDim * 1.2, maxDim * 1.5);
    camera.lookAt(arac.uzunluk / 2, arac.yukseklik / 2, arac.genislik / 2);

    const gridHelper = new THREE.GridHelper(
      Math.max(arac.uzunluk, arac.genislik) * 1.5,
      20,
      darkMode ? 0x444444 : 0xcccccc,
      darkMode ? 0x2a2a2a : 0xeeeeee
    );
    scene.add(gridHelper);

    const ambientLight = new THREE.AmbientLight(0xffffff, 0.6);
    scene.add(ambientLight);
    const directionalLight = new THREE.DirectionalLight(0xffffff, 0.4);
    directionalLight.position.set(1, 1, 1);
    scene.add(directionalLight);

    let mouseDown = false;
    let mouseX = 0;
    let mouseY = 0;
    let targetRotationX = Math.PI / 6;
    let targetRotationY = Math.PI / 4;
    let currentRotationX = Math.PI / 6;
    let currentRotationY = Math.PI / 4;

    const onMouseDown = (e) => {
      mouseDown = true;
      mouseX = e.clientX;
      mouseY = e.clientY;
    };

    const onMouseUp = () => {
      mouseDown = false;
    };

    const onMouseMove = (e) => {
      if (mouseDown) {
        const deltaX = e.clientX - mouseX;
        const deltaY = e.clientY - mouseY;
        mouseX = e.clientX;
        mouseY = e.clientY;

        targetRotationY += deltaX * 0.005;
        targetRotationX += deltaY * 0.005;
        targetRotationX = Math.max(-Math.PI / 2, Math.min(Math.PI / 2, targetRotationX));
      }
    };

    canvas.addEventListener('mousedown', onMouseDown);
    canvas.addEventListener('mouseup', onMouseUp);
    canvas.addEventListener('mousemove', onMouseMove);

    const animate = () => {
      requestAnimationFrame(animate);

      currentRotationX += (targetRotationX - currentRotationX) * 0.1;
      currentRotationY += (targetRotationY - currentRotationY) * 0.1;

      const radius = maxDim * 2;
      camera.position.x = arac.uzunluk / 2 + radius * Math.cos(currentRotationY) * Math.cos(currentRotationX);
      camera.position.y = arac.yukseklik / 2 + radius * Math.sin(currentRotationX);
      camera.position.z = arac.genislik / 2 + radius * Math.sin(currentRotationY) * Math.cos(currentRotationX);
      camera.lookAt(arac.uzunluk / 2, arac.yukseklik / 2, arac.genislik / 2);

      renderer.render(scene, camera);
    };
    animate();

    return () => {
      canvas.removeEventListener('mousedown', onMouseDown);
      canvas.removeEventListener('mouseup', onMouseUp);
      canvas.removeEventListener('mousemove', onMouseMove);
    };
  }, [sonuc, aracTipi, seciliKonteyner, darkMode]);

  const hesapla = () => {
    try {
      if (paketler.length === 0) {
        setSonuc({ hata: 'Lütfen en az bir paket ekleyin!' });
        return;
      }

      const arac = aracOlculeri[aracTipi];
      
      const cokBuyukPaketler = paketler.filter(p => 
        p.uzunluk > arac.uzunluk || 
        p.genislik > arac.genislik || 
        p.yukseklik > arac.yukseklik
      );
      
      if (cokBuyukPaketler.length === paketler.length) {
        setSonuc({ 
          hata: 'Tüm paketler seçili araç için çok büyük!' 
        });
        return;
      }
      
      const konteynerler = optimizeEt(paketler, arac);
      
      if (konteynerler.length === 0) {
        setSonuc({ hata: 'Bu araca hiçbir paket sığmıyor!' });
        return;
      }

      let toplamHacim = 0;
      let toplamAgirlik = 0;
      paketler.forEach(paket => {
        const paketHacim = (paket.uzunluk * paket.genislik * paket.yukseklik) / 1000000;
        toplamHacim += paketHacim * paket.adet;
        toplamAgirlik += paket.agirlik * paket.adet;
      });

      const kalanPaketler = [];
      paketler.forEach(paket => {
        let toplamYuklenen = 0;
        konteynerler.forEach(konteyner => {
          const yukPaket = konteyner.paketler.find(p => p.id === paket.id);
          if (yukPaket) {
            toplamYuklenen += yukPaket.yuklenecekAdet;
          }
        });
        if (toplamYuklenen < paket.adet) {
          kalanPaketler.push({
            ...paket,
            kalanAdet: paket.adet - toplamYuklenen
          });
        }
      });

      setSonuc({
        konteynerler,
        toplamHacim: toplamHacim.toFixed(2),
        toplamAgirlik: toplamAgirlik.toFixed(0),
        aracHacim: arac.hacim,
        aracAgirlik: arac.maxAgirlik,
        aracIsim: arac.isim,
        gerekenArac: konteynerler.length,
        kalanPaketler
      });
      
      setSeciliKonteyner(0);
    } catch (error) {
      console.error('Calculation error:', error);
      setSonuc({ 
        hata: 'Hesaplama sırasında bir hata oluştu.' 
      });
    }
  };

  const bgClass = darkMode ? 'bg-gray-900' : 'bg-gradient-to-br from-blue-50 to-blue-100';
  const cardClass = darkMode ? 'bg-gray-800 text-white' : 'bg-white text-gray-800';
  const inputClass = darkMode 
    ? 'bg-gray-700 border-gray-600 text-white focus:ring-blue-400' 
    : 'bg-white border-gray-300 text-gray-900 focus:ring-blue-500';
  const sectionClass = darkMode ? 'bg-gray-700' : 'bg-blue-50';

  return (
    <div className={`min-h-screen ${bgClass} p-3 sm:p-6 transition-colors duration-300`}>
      {shortcutsVisible && (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
          <div className={`${cardClass} rounded-lg p-6 max-w-md w-full shadow-2xl`}>
            <div className="flex items-center justify-between mb-4">
              <h3 className="text-lg font-bold flex items-center gap-2">
                <Keyboard className="w-5 h-5" />
                {t.shortcuts}
              </h3>
              <button onClick={() => setShortcutsVisible(false)} className="text-gray-500 hover:text-gray-700">✕</button>
            </div>
            <div className="space-y-2 text-sm">
              <div className="flex justify-between">
                <span>Ctrl + Enter</span>
                <span className="text-gray-500">{t.shortcutCalc}</span>
              </div>
              <div className="flex justify-between">
                <span>Ctrl + N</span>
                <span className="text-gray-500">{t.shortcutAdd}</span>
              </div>
              <div className="flex justify-between">
                <span>Ctrl + K</span>
                <span className="text-gray-500">{t.shortcuts}</span>
              </div>
              <div className="flex justify-between">
                <span>Escape</span>
                <span className="text-gray-500">{t.shortcutClear}</span>
              </div>
            </div>
          </div>
        </div>
      )}

      <div className="max-w-7xl mx-auto">
        <div className={`${cardClass} rounded-lg shadow-xl p-4 sm:p-6 mb-4 sm:mb-6`}>
          <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
            <div className="flex items-center gap-3">
              <Package className="w-6 h-6 sm:w-8 sm:h-8 text-blue-600" />
              <h1 className="text-xl sm:text-3xl font-bold">{t.title}</h1>
            </div>
            
            <div className="flex items-center gap-2 flex-wrap">
              <select 
                value={language}
                onChange={(e) => setLanguage(e.target.value)}
                className={`${inputClass} px-3 py-2 rounded-md text-sm border-2`}
              >
                <option value="tr">🇹🇷 Türkçe</option>
                <option value="en">🇬🇧 English</option>
                <option value="ru">🇷🇺 Русский</option>
              </select>
              
              <button
                onClick={() => setDarkMode(!darkMode)}
                className={`${inputClass} px-3 py-2 rounded-md hover:bg-opacity-80 transition`}
              >
                {darkMode ? <Sun className="w-5 h-5" /> : <Moon className="w-5 h-5" />}
              </button>
              
              <button
                onClick={() => setShortcutsVisible(true)}
                className={`${inputClass} px-3 py-2 rounded-md hover:bg-opacity-80 transition`}
              >
                <Keyboard className="w-5 h-5" />
              </button>
            </div>
          </div>
        </div>

        <div className="grid lg:grid-cols-3 gap-4 sm:gap-6">
          <div className={`${sectionClass} p-4 sm:p-6 rounded-lg`}>
            <h2 className="text-lg sm:text-xl font-semibold mb-4">{t.packageInfo}</h2>
            
            <div className="mb-4 flex gap-2">
              <button
                onClick={() => fileInputRef.current?.click()}
                className="flex-1 bg-green-600 text-white py-2 px-3 rounded-md hover:bg-green-700 flex items-center justify-center gap-2 transition text-xs sm:text-sm"
              >
                <Upload className="w-4 h-4" />
                {t.excelUpload}
              </button>
              <button
                onClick={() => setTopluEklemeAcik(!topluEklemeAcik)}
                className="flex-1 bg-purple-600 text-white py-2 px-3 rounded-md hover:bg-purple-700 flex items-center justify-center gap-2 transition text-xs sm:text-sm"
              >
                <ClipboardPaste className="w-4 h-4" />
                {t.paste}
              </button>
            </div>
            
            <button
              onClick={yeniYukleme}
              className="w-full mb-4 bg-orange-600 text-white py-2 px-3 rounded-md hover:bg-orange-700 flex items-center justify-center gap-2 transition text-xs sm:text-sm font-semibold"
            >
              <RefreshCw className="w-4 h-4" />
              🔄 {t.newLoad}
            </button>
            
            <input
              type="file"
              ref={fileInputRef}
              onChange={excelYukle}
              accept=".xlsx,.xls"
              className="hidden"
            />

            {topluEklemeAcik && (
              <div className={`mb-4 p-3 ${darkMode ? 'bg-purple-900' : 'bg-purple-50'} rounded-lg border ${darkMode ? 'border-purple-700' : 'border-purple-200'}`}>
                <textarea
                  value={pasteText}
                  onChange={(e) => setPasteText(e.target.value)}
                  className={`w-full px-2 py-2 ${inputClass} rounded-md text-xs font-mono`}
                  rows="4"
                  placeholder="Format: Adet [Tab] L [Tab] W [Tab] H [Tab] Weight [Tab] Cat"
                />
                <button
                  onClick={pastedenEkle}
                  className="w-full mt-2 bg-purple-600 text-white py-1 px-3 rounded-md hover:bg-purple-700 text-sm"
                >
                  {t.addPackage}
                </button>
              </div>
            )}
            
            <div className="space-y-3 sm:space-y-4">
              <div>
                <label className="block text-sm font-medium mb-1">{t.quantity}</label>
                <input
                  id="adet-input"
                  type="number"
                  min="1"
                  value={adet}
                  onChange={(e) => setAdet(e.target.value)}
                  className={`w-full px-3 py-2 ${inputClass} rounded-md`}
                  placeholder="10"
                />
              </div>

              <div className="grid grid-cols-3 gap-2">
                <div>
                  <label className="block text-xs font-medium mb-1">{t.length}</label>
                  <input
                    type="number"
                    min="1"
                    value={uzunluk}
                    onChange={(e) => setUzunluk(e.target.value)}
                    className={`w-full px-2 py-2 ${inputClass} rounded-md text-sm`}
                    placeholder="100"
                  />
                </div>
                <div>
                  <label className="block text-xs font-medium mb-1">{t.width}</label>
                  <input
                    type="number"
                    min="1"
                    value={genislik}
                    onChange={(e) => setGenislik(e.target.value)}
                    className={`w-full px-2 py-2 ${inputClass} rounded-md text-sm`}
                    placeholder="80"
                  />
                </div>
                <div>
                  <label className="block text-xs font-medium mb-1">{t.height}</label>
                  <input
                    type="number"
                    min="1"
                    value={yukseklik}
                    onChange={(e) => setYukseklik(e.target.value)}
                    className={`w-full px-2 py-2 ${inputClass} rounded-md text-sm`}
                    placeholder="60"
                  />
                </div>
              </div>

              <div>
                <label className="block text-sm font-medium mb-1 flex items-center gap-2">
                  <Weight className="w-4 h-4" />
                  {t.weight}
                </label>
                <input
                  type="number"
                  min="0.1"
                  value={agirlik}
                  onChange={(e) => setAgirlik(e.target.value)}
                  className={`w-full px-3 py-2 ${inputClass} rounded-md`}
                  placeholder="50"
                />
              </div>

              <div>
                <label className="block text-sm font-medium mb-1 flex items-center gap-2">
                  <Tag className="w-4 h-4" />
                  {t.category}
                </label>
                <select
                  value={kategori}
                  onChange={(e) => setKategori(e.target.value)}
                  className={`w-full px-3 py-2 ${inputClass} rounded-md`}
                >
                  <option value="">{t.selectCategory}</option>
                  <option value={t.categories.electronic}>{t.categories.electronic}</option>
                  <option value={t.categories.textile}>{t.categories.textile}</option>
                  <option value={t.categories.food}>{t.categories.food}</option>
                  <option value={t.categories.furniture}>{t.categories.furniture}</option>
                  <option value={t.categories.chemical}>{t.categories.chemical}</option>
                  <option value={t.categories.general}>{t.categories.general}</option>
                </select>
              </div>

              <div className={`p-3 ${darkMode ? 'bg-gray-700' : 'bg-blue-100'} rounded-lg space-y-2`}>
                <div className="text-xs font-semibold mb-2">🔧 Gelişmiş Özellikler</div>
                
                <label className="flex items-center gap-2 text-sm cursor-pointer">
                  <input
                    type="checkbox"
                    checked={dondurelebilir}
                    onChange={(e) => setDondurelebilir(e.target.checked)}
                    className="w-4 h-4"
                  />
                  <span>🔄 Döndürülebilir</span>
                </label>

                <label className="flex items-center gap-2 text-sm cursor-pointer">
                  <input
                    type="checkbox"
                    checked={paletUzerinde}
                    onChange={(e) => setPaletUzerinde(e.target.checked)}
                    className="w-4 h-4"
                  />
                  <span>📦 Palet üzerinde</span>
                </label>

                <div>
                  <label className="block text-xs font-medium mb-1">
                    ⚠️ Max İstif Yüksekliği (cm)
                  </label>
                  <input
                    type="number"
                    min="0"
                    value={maxIstifYuksekligi}
                    onChange={(e) => setMaxIstifYuksekligi(e.target.value)}
                    placeholder="Boş = Sınırsız"
                    className={`w-full px-2 py-1 ${inputClass} rounded-md text-sm`}
                  />
                </div>
              </div>

              <button
                onClick={paketEkle}
                className="w-full bg-blue-600 text-white py-2 px-4 rounded-md hover:bg-blue-700 flex items-center justify-center gap-2 transition"
              >
                <Plus className="w-5 h-5" />
                {t.addPackage}
              </button>
            </div>

            <button
              onClick={() => {
                setPaketler([]);
                setSonuc(null);
                setSeciliKonteyner(0);
              }}
              className="w-full mt-3 bg-red-600 text-white py-2 px-4 rounded-md hover:bg-red-700 flex items-center justify-center gap-2 transition"
            >
              <Trash2 className="w-5 h-5" />
              🗑️ {t.clearPackages}
            </button>

            {paketler.length > 0 && (
              <div className="mt-4 space-y-2 max-h-48 sm:max-h-64 overflow-y-auto">
                <div className="text-sm font-semibold">{t.addedPackages}</div>
                
                {benzersizKategoriler.map(kat => (
                  <div key={kat} className="mb-3">
                    <div className="flex items-center gap-2 mb-1">
                      <div 
                        className="w-3 h-3 rounded-full" 
                        style={{ backgroundColor: kategoriRenkleri[kat] || kategoriRenkleri['Genel'] }}
                      />
                      <span className="text-xs font-semibold">{kat}</span>
                    </div>
                    {paketler.filter(p => p.kategori === kat).map(paket => (
                      <div key={paket.id} className={`flex items-center justify-between p-2 ${cardClass} rounded text-xs sm:text-sm ml-5 mb-1`}>
                        <div className="flex-1">
                          <span className="font-semibold">{paket.adet}x</span>
                          <span className="ml-1 text-xs">
                            {paket.uzunluk}×{paket.genislik}×{paket.yukseklik}cm
                          </span>
                          <span className="text-blue-600 ml-1 text-xs font-semibold">
                            {paket.agirlik}kg
                          </span>
                          <div className="text-xs opacity-60 mt-1 flex flex-wrap gap-1">
                            {paket.dondurelebilir && <span>🔄</span>}
                            {paket.paletUzerinde && <span>📦</span>}
                            {paket.maxIstifYuksekligi && <span>⚠️{paket.maxIstifYuksekligi}cm</span>}
                          </div>
                        </div>
                        <button
                          onClick={() => paketSil(paket.id)}
                          className="text-red-600 hover:text-red-700"
                        >
                          <Trash2 className="w-4 h-4" />
                        </button>
                      </div>
                    ))}
                  </div>
                ))}
              </div>
            )}
          </div>

          <div className={`${sectionClass} p-4 sm:p-6 rounded-lg`}>
            <h2 className="text-lg sm:text-xl font-semibold mb-4">{t.vehicleType}</h2>
            
            <div className="space-y-2 max-h-80 sm:max-h-96 overflow-y-auto pr-2">
              <div className="text-xs font-semibold uppercase opacity-70 mb-2">{t.seaContainers}</div>
              
              {['20ft', '40ft', '20ft-hc', '40ft-hc', '20ft-reefer', '40ft-reefer', '20ft-opentop', '40ft-opentop'].map(tip => (
                <label key={tip} className={`flex items-center p-2 border-2 ${darkMode ? 'border-gray-600 hover:bg-gray-600' : 'border-gray-300 hover:bg-green-100'} rounded-lg cursor-pointer transition`}>
                  <input
                    type="radio"
                    value={tip}
                    checked={aracTipi === tip}
                    onChange={(e) => setAracTipi(e.target.value)}
                    className="w-4 h-4"
                  />
                  <div className="ml-2 flex-1">
                    <div className="font-semibold text-sm">{aracOlculeri[tip].isim}</div>
                    <div className="text-xs opacity-70">
                      {aracOlculeri[tip].uzunluk}×{aracOlculeri[tip].genislik}×{aracOlculeri[tip].yukseklik}cm ({aracOlculeri[tip].hacim}m³)
                    </div>
                    <div className="text-xs text-blue-600 font-semibold">Max: {aracOlculeri[tip].maxAgirlik.toLocaleString()} kg</div>
                  </div>
                </label>
              ))}

              <div className="text-xs font-semibold uppercase opacity-70 mb-2 mt-3">{t.landTransport}</div>

              {['standart-truck', 'mega-trailer', 'jumbo-trailer'].map(tip => (
                <label key={tip} className={`flex items-center p-2 border-2 ${darkMode ? 'border-gray-600 hover:bg-gray-600' : 'border-gray-300 hover:bg-green-100'} rounded-lg cursor-pointer transition`}>
                  <input
                    type="radio"
                    value={tip}
                    checked={aracTipi === tip}
                    onChange={(e) => setAracTipi(e.target.value)}
                    className="w-4 h-4"
                  />
                  <div className="ml-2 flex-1">
                    <div className="font-semibold text-sm">{aracOlculeri[tip].isim}</div>
                    <div className="text-xs opacity-70">
                      {aracOlculeri[tip].uzunluk}×{aracOlculeri[tip].genislik}×{aracOlculeri[tip].yukseklik}cm ({aracOlculeri[tip].hacim}m³)
                    </div>
                    <div className="text-xs text-blue-600 font-semibold">
                      Max: {aracOlculeri[tip].maxAgirlik.toLocaleString()} kg
                    </div>
                  </div>
                </label>
              ))}

              <div className="text-xs font-semibold uppercase opacity-70 mb-2 mt-3">⚙️ Özel Boyutlu Araç</div>

              <label className={`flex items-center p-2 border-2 ${darkMode ? 'border-gray-600 hover:bg-gray-600' : 'border-gray-300 hover:bg-yellow-100'} rounded-lg cursor-pointer transition`}>
                <input
                  type="radio"
                  value="custom"
                  checked={aracTipi === 'custom'}
                  onChange={(e) => {
                    setAracTipi(e.target.value);
                    setOzelAracAcik(true);
                  }}
                  className="w-4 h-4"
                />
                <div className="ml-2 flex-1">
                  <div className="font-semibold text-sm">Özel Araç</div>
                  <div className="text-xs opacity-70">Kendi boyutlarınızı girin</div>
                </div>
              </label>

              {ozelAracAcik && aracTipi === 'custom' && (
                <div className={`p-3 ${darkMode ? 'bg-gray-700' : 'bg-yellow-50'} rounded-lg border-2 ${darkMode ? 'border-yellow-600' : 'border-yellow-300'} space-y-2`}>
                  <input
                    type="text"
                    placeholder="Araç İsmi (örn: Kamyonet)"
                    value={ozelAracBilgi.isim}
                    onChange={(e) => setOzelAracBilgi({...ozelAracBilgi, isim: e.target.value})}
                    className={`w-full px-2 py-1 ${inputClass} rounded text-xs`}
                  />
                  <div className="grid grid-cols-3 gap-2">
                    <input
                      type="number"
                      placeholder="Uzunluk (cm)"
                      value={ozelAracBilgi.uzunluk}
                      onChange={(e) => setOzelAracBilgi({...ozelAracBilgi, uzunluk: e.target.value})}
                      className={`w-full px-2 py-1 ${inputClass} rounded text-xs`}
                    />
                    <input
                      type="number"
                      placeholder="Genişlik (cm)"
                      value={ozelAracBilgi.genislik}
                      onChange={(e) => setOzelAracBilgi({...ozelAracBilgi, genislik: e.target.value})}
                      className={`w-full px-2 py-1 ${inputClass} rounded text-xs`}
                    />
                    <input
                      type="number"
                      placeholder="Yükseklik (cm)"
                      value={ozelAracBilgi.yukseklik}
                      onChange={(e) => setOzelAracBilgi({...ozelAracBilgi, yukseklik: e.target.value})}
                      className={`w-full px-2 py-1 ${inputClass} rounded text-xs`}
                    />
                  </div>
                  <input
                    type="number"
                    placeholder="Max Ağırlık (kg)"
                    value={ozelAracBilgi.maxAgirlik}
                    onChange={(e) => setOzelAracBilgi({...ozelAracBilgi, maxAgirlik: e.target.value})}
                    className={`w-full px-2 py-1 ${inputClass} rounded text-xs`}
                  />
                </div>
              )}
            </div>

            <button
              onClick={hesapla}
              className="w-full mt-4 bg-green-600 text-white py-3 px-4 rounded-md hover:bg-green-700 flex items-center justify-center gap-2 transition font-semibold"
            >
              <Calculator className="w-5 h-5" />
              {t.calculate}
            </button>
          </div>

          {sonuc && !sonuc.hata && (
            <div className={`${sectionClass} p-4 sm:p-6 rounded-lg`}>
              <h2 className="text-lg sm:text-xl font-semibold mb-4">{t.summary}</h2>
              
              <div className="space-y-3">
                <div className={`${cardClass} p-3 rounded-lg`}>
                  <div className="text-xs opacity-70">{t.totalVolume}</div>
                  <div className="text-xl font-bold text-blue-600">{sonuc.toplamHacim} m³</div>
                </div>
                
                <div className={`${cardClass} p-3 rounded-lg`}>
                  <div className="text-xs opacity-70 flex items-center gap-1">
                    <Weight className="w-3 h-3" />
                    {t.totalWeight}
                  </div>
                  <div className="text-xl font-bold text-orange-600">{sonuc.toplamAgirlik} kg</div>
                </div>
                
                <div className={`${cardClass} p-3 rounded-lg`}>
                  <div className="text-xs opacity-70">{t.requiredVehicles}</div>
                  <div className="text-xl font-bold text-green-600">{sonuc.gerekenArac}</div>
                  <div className="text-xs opacity-70 mt-1">{sonuc.aracIsim}</div>
                </div>

                <button
                  onClick={pdfRaporOlustur}
                  className="w-full bg-red-600 text-white py-3 px-4 rounded-md hover:bg-red-700 flex items-center justify-center gap-2 transition font-semibold"
                >
                  <FileText className="w-5 h-5" />
                  📄 {t.pdfReport}
                </button>

                <button
                  onClick={excelAktar}
                  className="w-full mt-2 bg-green-600 text-white py-3 px-4 rounded-md hover:bg-green-700 flex items-center justify-center gap-2 transition font-semibold"
                >
                  <FileSpreadsheet className="w-5 h-5" />
                  📊 {t.excelExport}
                </button>

                {sonuc.kalanPaketler.length > 0 && (
                  <div className="bg-yellow-50 dark:bg-yellow-900 border-l-4 border-yellow-500 p-3">
                    <div className="font-semibold text-yellow-800 dark:text-yellow-200 text-sm mb-1">⚠️ {t.remainingPackages}</div>
                    <div className="space-y-1">
                      {sonuc.kalanPaketler.map(paket => (
                        <div key={paket.id} className="text-xs text-yellow-700 dark:text-yellow-300">
                          • {paket.kalanAdet} × ({paket.uzunluk}×{paket.genislik}×{paket.yukseklik}cm, {paket.agirlik}kg)
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            </div>
          )}
        </div>

        {sonuc && !sonuc.hata && sonuc.konteynerler && (
          <>
            <div className={`${cardClass} rounded-lg shadow-xl p-4 sm:p-6 mt-4 sm:mt-6`}>
              <h2 className="text-xl sm:text-2xl font-semibold mb-4">{t.distribution}</h2>
              <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-4">
                {sonuc.konteynerler.map((konteyner, index) => (
                  <div 
                    key={index}
                    onClick={() => setSeciliKonteyner(index)}
                    className={`p-3 sm:p-4 rounded-lg border-2 cursor-pointer transition ${
                      seciliKonteyner === index 
                        ? 'border-blue-500 bg-blue-50 dark:bg-blue-900' 
                        : `border-gray-200 ${darkMode ? 'bg-gray-700' : 'bg-gray-50'} hover:border-blue-300`
                    }`}
                  >
                    <div className="flex items-center gap-2 mb-3">
                      <Box className="w-5 h-5 text-blue-600" />
                      <h3 className="font-bold text-base sm:text-lg">
                        {index + 1}. {sonuc.aracIsim}
                      </h3>
                    </div>
                    
                    <div className="space-y-2">
                      <div className="text-xs sm:text-sm">
                        <span className="font-semibold">{t.volumeUtilization}:</span>
                        <div className="w-full bg-gray-200 dark:bg-gray-600 rounded-full h-3 sm:h-4 mt-1">
                          <div
                            className="bg-green-500 h-3 sm:h-4 rounded-full flex items-center justify-center text-xs text-white font-semibold"
                            style={{ width: `${konteyner.dolulukOrani}%` }}
                          >
                            {konteyner.dolulukOrani}%
                          </div>
                        </div>
                      </div>

                      <div className="text-xs sm:text-sm">
                        <span className="font-semibold">{t.weightUtilization}:</span>
                        <div className="w-full bg-gray-200 dark:bg-gray-600 rounded-full h-3 sm:h-4 mt-1">
                          <div
                            className="bg-orange-500 h-3 sm:h-4 rounded-full flex items-center justify-center text-xs text-white font-semibold"
                            style={{ width: `${konteyner.agirlikOrani}%` }}
                          >
                            {konteyner.agirlikOrani}%
                          </div>
                        </div>
                      </div>
                      
                      <div className="border-t pt-2 mt-2 border-gray-300 dark:border-gray-600">
                        <div className="text-xs font-semibold mb-1">{t.loadedPackages}:</div>
                        {konteyner.paketler.map((paket, pIndex) => (
                          <div key={pIndex} className="text-xs flex items-center gap-1 opacity-80">
                            <div 
                              className="w-2 h-2 rounded-full" 
                              style={{ 
                                backgroundColor: kategoriRenkleri[paket.kategori] || kategoriRenkleri['Genel']
                              }}
                            />
                            <span className="font-semibold">{paket.yuklenecekAdet}×</span>
                            <span>
                              ({paket.uzunluk}×{paket.genislik}×{paket.yukseklik}, {paket.agirlik}kg)
                            </span>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className={`${cardClass} rounded-lg shadow-xl p-4 sm:p-6 mt-4 sm:mt-6`}>
              <h2 className="text-xl sm:text-2xl font-semibold mb-4">
                {t.view3D} - {seciliKonteyner + 1}. {sonuc.aracIsim}
              </h2>
              
              <div className="mb-4 flex flex-wrap gap-2 sm:gap-3">
                {benzersizKategoriler.map(kat => (
                  <div key={kat} className={`flex items-center gap-2 ${darkMode ? 'bg-gray-700' : 'bg-gray-50'} px-3 py-1 rounded-full`}>
                    <div 
                      className="w-3 h-3 rounded-full" 
                      style={{ backgroundColor: kategoriRenkleri[kat] || kategoriRenkleri['Genel'] }}
                    />
                    <span className="text-xs sm:text-sm font-medium">{kat}</span>
                  </div>
                ))}
              </div>
              
              <div className={`${darkMode ? 'bg-gray-700' : 'bg-gray-100'} rounded-lg p-2 sm:p-4`}>
                <canvas
                  ref={canvasRef}
                  style={{ width: '100%', height: '400px', display: 'block' }}
                  className="sm:h-96 md:h-[600px]"
                />
                <p className="text-xs sm:text-sm opacity-70 mt-3 text-center">
                  🖱️ {t.rotateInfo} • {t.blueLines} • {t.coloredLines}
                </p>
              </div>
            </div>
          </>
        )}

        {sonuc && sonuc.hata && (
          <div className={`${cardClass} rounded-lg shadow-xl p-6 mt-6`}>
            <div className="bg-red-100 dark:bg-red-900 border-l-4 border-red-500 p-4 text-red-700 dark:text-red-200">
              {sonuc.hata}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
